import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  CatalogProductsListComponent
} from '~shared/modules/catalog/catalog-products-list/catalog-products-list.component';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { TranslateModule } from '@ngx-translate/core';
import { MmFlexLayoutModule } from '@metromarkets/components';
import { ImageHeaderModule } from '~shared/components/image-header/image-header.module';
import { CategoryFacetsCarouselModule } from '~shared/components/category-facets-carousel/category-facets.module';
import { StickyModule } from '~shared/directives/sticky/sticky.module';
import { FiltersModule } from '~app/modules/filters/filters.module';
import { CategoryCarouselModule } from '~shared/modules/category-carousel/category-carousel.module';

import {
  FilterFacetsCarouselModule
} from '~shared/modules/catalog/filter-facets-carousel/filter-facets-carousel.module';
import {
  CatalogBodyModule,
  CategoryChildrenModule,
  CatalogToolbarModule,
  CatalogActionsModule
} from './modules'


@NgModule({
  declarations: [
    CatalogProductsListComponent,
  ],
  imports: [
    CommonModule,
    QaLocatorsModule,
    TranslateModule,
    MmFlexLayoutModule,
    ImageHeaderModule,
    StickyModule,
    FiltersModule,
    CategoryCarouselModule,
    CatalogBodyModule,
    CategoryChildrenModule,
    FilterFacetsCarouselModule,
    CatalogToolbarModule,
    CatalogActionsModule,
    CategoryFacetsCarouselModule
  ],
  exports: [
    CatalogProductsListComponent
  ]
})
export class CatalogProductsListModule {}
